import React, { useState, useMemo } from "react";
import "./FastAddPlayer.css";
import { createPlayer } from "../../../services/player.services";
import { useSelector } from 'react-redux';

const CreateFastPlayerOverlay = ({
  isVisible,
  onBackdropPress,
  tid,
  handleGetPlayers,
  playerData,
}) => {
  const user = useSelector(state => state.auth.user);

  const [selectedNumbers, setSelectedNumbers] = useState(new Set()); // Changed to Set for multiple selections
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAddFastPlayer = async () => {
    if (selectedNumbers.size === 0) return;

    try {
      setLoading(true);
      // Create all players in parallel
await Promise.all(
  Array.from(selectedNumbers).map(number => {
    const payload = {
      teamId: tid,
      firstName: 'QuickAdd',  // Changed from 'Fast'
      lastName: `Player#${number}`,  // Changed from 'Player' and includes number
      email: null,
      homeJersey: number.toString(),
      awayJersey: number.toString(),
      position1: 'None',
      position2: 'None',
      height: '',
      weight: '',
      grade: '',
      phone: 0,
      isCaptain: false,
    };
    return createPlayer(payload, user?.token);
  })
);
      
      await handleGetPlayers();
      onBackdropPress(); // close modal
      setSelectedNumbers(new Set()); // reset
    } catch (e) {
      setError(e);
      console.log('ERROR in FastAddPlayer =>', e.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const assignedNumbers = useMemo(() => new Set(
    playerData?.map(p => parseInt(p?.homeJersey)).filter(num => !isNaN(num))
  ), [playerData]);

  const handleCross = () => {
    setSelectedNumbers(new Set());
    onBackdropPress();
  }

  const toggleNumberSelection = (number) => {
    setSelectedNumbers(prev => {
      const newSelection = new Set(prev);
      if (newSelection.has(number)) {
        newSelection.delete(number);
      } else {
        newSelection.add(number);
      }
      return newSelection;
    });
  };


    return (
        <div className={`modal-fastAdd ${isVisible ? 'show' : ''}`}>
            {error && (
                <div className="error-overlay" onClick={() => setError(null)}>
                    <p>{error.message || "Something went wrong"}</p>
                </div>
            )}
            <div className="modal-content-fastAdd" style={{padding: '20px'}}> 
                <div className="modal-header-fastAdd" style={{ marginBottom: '10px' }}>
                    <h2>FAST ADD PLAYER</h2>
                    <button className="cross-button" onClick={handleCross}>
                        ✖
                    </button>
                </div>
                <div className="grid">
                    {Array.from({ length: 100 }, (_, i) => i)
                        .filter((i) => !assignedNumbers.has(i))
                        .map((i) => (
                            <button
                                key={i}
                                className={`number-box ${selectedNumbers.has(i) ? "selected" : ""
                                    }`}
                                onClick={() => toggleNumberSelection(i)}
                            >
                                {i}
                            </button>
                        ))}
                </div>

                <button
                    className="add-button"
                    onClick={handleAddFastPlayer}
                    disabled={selectedNumbers.size === 0 || loading}
                >
                    {loading
                        ? "Loading..."
                        : `Add ${selectedNumbers.size > 0 ? `(${selectedNumbers.size})` : ""
                        }`}
                </button>
            </div>
        </div>
    );
};

export default CreateFastPlayerOverlay;
